import {redirectToPHPComponent} from '@/router/default';
import {type RouteRecordRaw} from 'vue-router';

const NotificationList = () => import('../views/notification/NotificationList.vue');

let meta: MetaData = {module: 'application'};

let notification: RouteRecordRaw[] = [
    {
        name: 'notification-list',
        path: '/notification/list/',
        component: NotificationList,
        meta,
    },
    {
        name: 'notification-list-event',
        path: '/notification/list/event/:eventId',
        component: NotificationList,
        meta,
    },
    {
        path: '/notification/confirm-read/id/:id',
        name: 'notificationConfirmRead',
        component: redirectToPHPComponent,
        meta,
    },
    // all other notification routes redirect to notification-list (maybe to 404?)
    {
        path: '/notification/:wildcard*',
        redirect: {name: 'notification-list'},
        meta,
    },
];

export default notification;
